import React from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FocusButton, FocusDiv } from '#/widgets/ui';
import BaseModal from '../../common/BaseModal/BaseModal';
// focus handling
import FocusModal from '../../common/FocusModal/FocusModal';
import { FILTER_CONTENT } from '#/utils/navigationHelper';

import { getContentBlocking } from '#/redux/modules/accedoOne/selectors';
import { getCurrentVideo } from '#/redux/modules/appPlayer/selectors';
import { getAssetData } from '#/redux/modules/brightcove/selectors';
import { sendBlockContent } from '#/redux/modules/firestore/actions';
import { actions } from '#/redux/modules/modal/actions';
import {
  updateVideosBlockedById,
  updateShowsBlockedById,
} from '#/redux/modules/identity/actions';

import styles from './ContentFilteringModal.scss';
import { isWorkstation, isTizen } from '#/utils/componentStyleConfig';
import { rerenderApplication } from '#/redux/modules/menu/actions';

const {
  CONTAINER,
  TV_CONTENT_MODAL_ACTION_BUTTON,
  TV_CONTENT_MODAL_HIDE_VIDEO_BUTTON,
  TV_CONTENT_MODAL_HIDE_SERIES_BUTTON,
} = FILTER_CONTENT;

const navMap = {
  CONTAINER: {
    id: CONTAINER,
  },
  ACTION_BUTTON: {
    id: TV_CONTENT_MODAL_ACTION_BUTTON,
  },
  HIDE_VIDEO_BUTTON: {
    id: TV_CONTENT_MODAL_HIDE_VIDEO_BUTTON,
  },
  HIDE_SERIES_BUTTON: {
    id: TV_CONTENT_MODAL_HIDE_SERIES_BUTTON,
  },
};

const ContentFilteringModal = ({ history }) => {
  const dispatch = useDispatch();
  const contentBlocking = useSelector(getContentBlocking);
  const currentVideo = useSelector(state => getCurrentVideo(state));
  const videoInfo = useSelector(state => getAssetData(state));

  const {
    blockContentModal: {
      title,
      description,
      ctaBlockShowVideos,
      ctaBlockVideo,
      ctaCancel,
    },
  } = contentBlocking;

  const hideVideo = async () => {
    const videoData = {
      id: `${currentVideo.videoId}`,
      name: currentVideo.videoTitle,
      reference_id: currentVideo.videoReferenceId,
      thumbnail: currentVideo.thumbnail,
      custom_fields: {
        subtitle: currentVideo.videoShowTitle,
        episode_key_art_horizontal: currentVideo.episode_key_art_horizontal,
      },
      duration: videoInfo.duration,
    };
    const videoAnalyticsData = {
      video_id: `${currentVideo.videoId}`,
    };
    await dispatch(
      updateVideosBlockedById(currentVideo.videoId, true, videoData),
    );
    await dispatch(sendBlockContent(videoAnalyticsData));
    await dispatch(actions.closeModal());
    await dispatch(
      actions.openModal({
        modalId: 'InfoModal',
        modalData: { infoMessage: 'Reloading Content' },
      }),
    );
    if (!isTizen()) {
      history.goBack();
      window?.location.reload();
    } else {
      await dispatch(rerenderApplication(true));
    }
  };

  const hideShow = async () => {
    const showData = {
      id: `${videoInfo.custom_fields.show_id}`,
      name: videoInfo.custom_fields.series_show_name,
      key_art_horizontal_image_path: videoInfo.thumbnail,
    };
    const showAnalyticsData = {
      show_id: `${videoInfo.custom_fields.show_id}`,
    };
    await dispatch(
      updateShowsBlockedById(
        `${videoInfo.custom_fields.show_id}`,
        true,
        showData,
      ),
    );
    await dispatch(sendBlockContent(showAnalyticsData));
    await dispatch(actions.closeModal());
    await dispatch(
      actions.openModal({
        modalId: 'InfoModal',
        modalData: { infoMessage: 'Reloading Content' },
      }),
    );
    if (!isTizen()) {
      history.goBack();
      window?.location.reload();
    } else {
      await dispatch(rerenderApplication(true));
    }
  };

  return (
    <FocusModal>
      <BaseModal
        showSaveButton={false}
        showCloseX={!!isWorkstation}
        showCancelButton
        cancelButtonText={ctaCancel}
        className={styles.baseContainer}
        saveButtonContainerClassName={styles.cancelButtonContainer}
        cancelButtonClassName={styles.cancelButton}
        cancelButtonDisabled={false}
        nav={{
          id: navMap.ACTION_BUTTON.id,
          parent: navMap.CONTAINER.id,
          nextup: navMap.HIDE_SERIES_BUTTON.id,
        }}
      >
        <FocusDiv
          className={styles.modalContainer}
          nav={{
            id: navMap.CONTAINER.id,
            forwardFocus: navMap.HIDE_VIDEO_BUTTON.id,
          }}
        >
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
          <FocusButton
            onClick={hideVideo}
            className={styles.hideButton}
            nav={{
              id: navMap.HIDE_VIDEO_BUTTON.id,
              nextdown: navMap.HIDE_SERIES_BUTTON.id,
            }}
          >
            {ctaBlockVideo}
          </FocusButton>
          <FocusButton
            onClick={hideShow}
            className={styles.hideButton}
            nav={{
              id: navMap.HIDE_SERIES_BUTTON.id,
              nextdown: navMap.ACTION_BUTTON.id,
              nextup: navMap.HIDE_VIDEO_BUTTON.id,
            }}
          >
            {ctaBlockShowVideos}
          </FocusButton>
        </FocusDiv>
      </BaseModal>
    </FocusModal>
  );
};

ContentFilteringModal.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ContentFilteringModal);
